<template>
  <div class="page" :class="{'page__has-bar': !readonly}">
    <div class="page__bd">
      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__hd">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">单据编号</label>
            <em class="weui-form-preview__value">{{form.main.su_code}}</em>
          </div>
        </div>
        <custom-layout class="weui-form-preview__bd" :view-config="customViewConfig">
          <div class="weui-form-preview__item" slot="su_emname">
            <label class="weui-form-preview__label">{{customLabel.su_emname || "申请人"}}</label>
            <span class="weui-form-preview__value">
              {{form.main.su_emname}}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="su_department">
            <label class="weui-form-preview__label">{{customLabel.su_department || "需求部门"}}</label>
            <span class="weui-form-preview__value">{{form.main.su_department}}</span>
          </div>
          <div class="weui-form-preview__item" slot="su_type">
            <label class="weui-form-preview__label">{{customLabel.su_type || "类型"}}</label>
            <span class="weui-form-preview__value">{{form.main.su_type}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.su_sourcecode" slot="su_sourcecode">
            <label class="weui-form-preview__label">{{customLabel.su_sourcecode || "项目编号"}}</label>
            <span class="weui-form-preview__value">{{form.main.su_sourcecode}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.pj_dename" slot="pj_dename">
            <label class="weui-form-preview__label">{{customLabel.pj_dename || "项目名称"}}</label>
            <span class="weui-form-preview__value">{{form.main.pj_dename}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.pj_emname" slot="pj_emname">
            <label class="weui-form-preview__label">{{customLabel.pj_emname || "项目负责人"}}</label>
            <span class="weui-form-preview__value">{{form.main.pj_emname}}</span>
          </div>
          <div class="weui-form-preview__item" v-if="form.main.pj_product_type" slot="pj_product_type">
            <label class="weui-form-preview__label">{{customLabel.pj_product_type || "产品类型"}}</label>
            <span class="weui-form-preview__value">{{form.main.pj_product_type}}</span>
          </div>
          <div class="weui-form-preview__item" slot="su_remark">
            <label class="weui-form-preview__label">{{customLabel.su_remark || "申请原因"}}</label>
            <span class="weui-form-preview__value">{{form.main.su_remark}}</span>
          </div>

        </custom-layout>
      </div>

      <div class="form-preview weui-form-preview">
        <div
          class="weui-form-preview__bd form-detail-preview"
          v-for="item in form.items"
          :key="item.id"
        >
          <div class="form-detail-preview_num">{{ item.sd_detno }}</div>
          <custom-layout :view-config="customViewConfig" position="detail1">
          <div class="weui-form-preview__item" slot="sd_name">
            <label class="weui-form-preview__label">{{customLabel.sd_name || "用品名称"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ item.sd_name }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="sd_spec">
            <label class="weui-form-preview__label">{{customLabel.sd_spec || "用品规格"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ item.sd_spec }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="sd_amount">
            <label class="weui-form-preview__label">{{customLabel.sd_amount || "金额"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ numberFormat(item.sd_amount, '¥#,##0.00') }}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="sd_remark">
            <label class="weui-form-preview__label">{{customLabel.sd_remark || "备注"}}</label>
            <span class="weui-form-preview__value weui-form-preview__value-icon"
              >{{ item.sd_remark }}
            </span>
          </div>
          </custom-layout>
        </div>
      </div>

      <div class="form-preview weui-form-preview">
        <div class="weui-form-preview__bd" slot="creatorName">
          <div class="weui-form-preview__item">
            <label class="weui-form-preview__label">{{customLabel.creatorName || "录入人"}}</label>
            <span class="weui-form-preview__value">
              {{form.main.creatorName}}
            </span>
          </div>
          <div class="weui-form-preview__item" slot="createTime">
            <label class="weui-form-preview__label">{{customLabel.createTime || "录入日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.createTime}}</span>
          </div>
          <div class="weui-form-preview__item" slot="su_auditman">
            <label class="weui-form-preview__label">{{customLabel.su_auditman || "审核人"}}</label>
            <span class="weui-form-preview__value">{{form.main.su_auditman}}</span>
          </div>
          <div class="weui-form-preview__item" slot="su_auditdate">
            <label class="weui-form-preview__label">{{customLabel.su_auditdate || "审核日期"}}</label>
            <span class="weui-form-preview__value" v-format="'yyyy-MM-dd'">{{form.main.su_auditdate}}</span>
          </div>
        </div>
      </div>
      <file-list v-model="form.main.su_attach" />
    </div>

    <div class="footer-bar weui-dialog__ft" v-if="!readonly">
      <router-link
        :to="'/oa/supplies_apply_edit?id='+form.main.id"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
      >编辑</router-link>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_primary"
        @click="f_audit"
      >审核</a>
      <a
        href="javascript:;"
        v-if="editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="p_remove"
      >删除</a>
      <a
        href="javascript:;"
        v-if="!editable"
        class="weui-dialog__btn weui-dialog__btn_default"
        @click="f_unaudit"
      >反审</a>
    </div>
  </div>
</template>

<script>
import CustomLayout from "@/components/layout/CustomLayout.vue";
import FileList from "@/components/FileList.vue";
import process from "@/mixins/process.js"

export default {
  mixins: [process],
   components: {
    CustomLayout,
    FileList
  },
  data() {
    return {
      baseUrl: "/api/oa/supplies",
      codeField: "su_code",
      statusField: "su_statuscode",
      caller: "Supplies",
      xtype: "oa-supplies-formpanel",
    };
  }
}
</script>